"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[1375],{

/***/ 45264:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ components_ReviewBlock; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./styles/Home.module.css
var Home_module = __webpack_require__(7160);
var Home_module_default = /*#__PURE__*/__webpack_require__.n(Home_module);
// EXTERNAL MODULE: ./node_modules/@mui/material/styles/useTheme.js
var useTheme = __webpack_require__(2734);
// EXTERNAL MODULE: ./node_modules/@mui/material/Box/Box.js + 1 modules
var Box = __webpack_require__(87357);
// EXTERNAL MODULE: ./node_modules/@mui/material/Button/Button.js + 2 modules
var Button = __webpack_require__(83321);
// EXTERNAL MODULE: ./node_modules/react-swipeable-views/lib/index.js
var lib = __webpack_require__(77314);
// EXTERNAL MODULE: ./node_modules/react-swipeable-views-utils/lib/index.js
var react_swipeable_views_utils_lib = __webpack_require__(42850);
// EXTERNAL MODULE: ./node_modules/@mui/material/styles/styled.js
var styled = __webpack_require__(90948);
// EXTERNAL MODULE: ./node_modules/@fortawesome/react-fontawesome/index.es.js
var index_es = __webpack_require__(67814);
// EXTERNAL MODULE: ./node_modules/react-redux/es/index.js + 14 modules
var es = __webpack_require__(41248);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./redux/Frontend/ListingsFilter/redux/slice.tsx
var slice = __webpack_require__(2576);
// EXTERNAL MODULE: ./redux/Frontend/ListingsFilter/types.tsx
var types = __webpack_require__(6421);
// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(25675);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
;// CONCATENATED MODULE: ./components/Carousel.tsx














const AutoPlaySwipeableViews = (0,react_swipeable_views_utils_lib/* autoPlay */.bH)(lib/* default */.ZP);

function SwipeableTextMobileStepper() {
    const theme = (0,useTheme/* default */.Z)();
    const [activeStep, setActiveStep] = react.useState(0);
    const maxSteps = reviewDetails.length;
    const [autoPlaySwitch, setAutoPlaySwitch] = (0,react.useState)(true);
    const handleNext = ()=>{
        setActiveStep((prevActiveStep)=>prevActiveStep + 1);
    };
    const handleBack = (label)=>{
        setActiveStep((activeStep)=>activeStep - 1);
    };
    const handleStepChange = (step)=>{
        setActiveStep(step);
        if (step == 4) {
            setAutoPlaySwitch(false);
        }
    };
    const handleChange = (index)=>{
        setActiveStep(index);
    };
    const YearButton = (0,styled/* default */.ZP)(Button/* default */.Z)({
        fontFamily: "Cochin",
        fontWeight: 700,
        fontsize: 25,
        color: "#00245B",
        "&:hover": {
            backgroundColor: "#F8F6F0",
            borderColor: "#F8F6F0",
            boxShadow: "none"
        }
    });
    const dispatch = (0,es/* useDispatch */.I0)();
    const router = (0,next_router.useRouter)();
    const handleRoute = (retreatTypeFilter, activityFilter)=>{
        var _qr_activityFilter;
        let qr = {
            retreatTypeFilter,
            activityFilter
        };
        !qr.retreatTypeFilter && delete qr.retreatTypeFilter;
        !qr.activityFilter && delete qr.activityFilter;
        dispatch(slice/* actions.updateListingsFilterFormValue */.Nw.updateListingsFilterFormValue({
            key: "retreatTypeFilter",
            value: parseInt(qr.retreatTypeFilter) || []
        }));
        if (((_qr_activityFilter = qr.activityFilter) === null || _qr_activityFilter === void 0 ? void 0 : _qr_activityFilter.length) > 0) {
            dispatch(slice/* actions.setActivityList */.Nw.setActivityList(qr.activityFilter));
        }
        router.push({
            pathname: "/listing",
            query: qr
        });
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
            sx: {
                flexGrow: 1
            },
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(AutoPlaySwipeableViews, {
                axis: theme.direction === "rtl" ? "x-reverse" : "x",
                index: activeStep,
                onChangeIndex: handleStepChange,
                interval: 3000,
                enableMouseEvents: true,
                children: reviewDetails.map((item, index)=>/*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                                sx: {
                                    display: {
                                        xs: "none",
                                        sm: "block"
                                    },
                                    flexGrow: 1,
                                    height: "100%",
                                    borderRight: 1,
                                    borderBottom: 1,
                                    borderRadius: 2,
                                    padding: "0 5px 5px 0",
                                    borderRightColor: "#dcdcdc !important",
                                    borderBottomColor: "#dcdcdc !important"
                                },
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                                    sx: {
                                        flexGrow: 1,
                                        height: "100%",
                                        borderRight: 1,
                                        borderBottom: 1,
                                        borderRadius: 2,
                                        padding: "0 5px 5px 0",
                                        borderRightColor: "#dcdcdc !important",
                                        borderBottomColor: "#dcdcdc !important"
                                    },
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "card h-100",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                className: "card-body pb-0",
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                        className: "d-flex",
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                                                    src: item.reviewerImg,
                                                                    alt: "Card image cap",
                                                                    width: 65,
                                                                    height: 65,
                                                                    style: {
                                                                        borderRadius: "50%",
                                                                        objectFit: "cover"
                                                                    },
                                                                    className: "img-fluid card-img-top carouselImage"
                                                                })
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                className: "ms-3 d-flex align-items-center",
                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                    className: "d-block",
                                                                    children: [
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                                                                            className: "mb-0",
                                                                            children: item.reviewer
                                                                        }),
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                            className: "mt-0",
                                                                            children: [
                                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* FontAwesomeIcon */.G, {
                                                                                    icon: "star",
                                                                                    width: "14",
                                                                                    className: "star mt-0",
                                                                                    style: {
                                                                                        color: "#f7ca18"
                                                                                    }
                                                                                }),
                                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* FontAwesomeIcon */.G, {
                                                                                    icon: "star",
                                                                                    width: "14",
                                                                                    className: "star mt-0",
                                                                                    style: {
                                                                                        color: "#f7ca18"
                                                                                    }
                                                                                }),
                                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* FontAwesomeIcon */.G, {
                                                                                    icon: "star",
                                                                                    width: "14",
                                                                                    className: "star mt-0",
                                                                                    style: {
                                                                                        color: "#f7ca18"
                                                                                    }
                                                                                }),
                                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* FontAwesomeIcon */.G, {
                                                                                    icon: "star",
                                                                                    width: "14",
                                                                                    className: "star mt-0",
                                                                                    style: {
                                                                                        color: "#f7ca18"
                                                                                    }
                                                                                }),
                                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* FontAwesomeIcon */.G, {
                                                                                    icon: "star",
                                                                                    width: "14",
                                                                                    className: "star mt-0",
                                                                                    style: {
                                                                                        color: "#f7ca18"
                                                                                    }
                                                                                })
                                                                            ]
                                                                        })
                                                                    ]
                                                                })
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("h5", {
                                                        className: "mt-3",
                                                        children: [
                                                            '"',
                                                            item.review,
                                                            '"'
                                                        ]
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                className: "card-footer bg-white border-0 d-flex justify-content-between align-items-center",
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        className: "d-flex justify-md-content-center ",
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                            className: "mb-0",
                                                            children: item.reviewDept
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                        children: [
                                                            item.reviewDept == "Yoga Retreat" && /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                                                className: "btn btnHover px-3 px-lg-2 px-xl-3",
                                                                onClick: ()=>handleRoute(null, "Yoga Retreat"),
                                                                children: "Yoga Retreats"
                                                            }),
                                                            item.reviewDept == "Online Retreat" && /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                                                className: "btn btnHover px-3 px-lg-2 px-xl-3",
                                                                onClick: ()=>handleRoute(types/* RetreatsTypeEnum.Online */.zZ.Online, null),
                                                                children: "Online Retreats"
                                                            }),
                                                            item.reviewDept == "Yoga Teacher Training" && /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                                                className: "btn btnHover px-3 px-lg-2 px-xl-3",
                                                                onClick: ()=>handleRoute(null, "Yoga Teacher Training"),
                                                                children: "Online Yoga Training"
                                                            })
                                                        ]
                                                    })
                                                ]
                                            })
                                        ]
                                    }, index)
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                                sx: {
                                    display: {
                                        xs: "block",
                                        sm: "none"
                                    },
                                    flexGrow: 1,
                                    height: "100%",
                                    borderBottom: 1,
                                    borderRadius: 2,
                                    padding: "0 5px 5px 0",
                                    borderBottomColor: "#dcdcdc !important"
                                },
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                                    sx: {
                                        flexGrow: 1,
                                        borderBottom: 1,
                                        borderRadius: 2,
                                        height: "100%",
                                        padding: "0 5px 5px 0",
                                        borderBottomColor: "#dcdcdc !important"
                                    },
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "card h-100",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                className: "card-body pb-0",
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                        className: "d-flex",
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                                                    src: item.reviewerImg,
                                                                    alt: "Card image cap",
                                                                    width: 65,
                                                                    height: 65,
                                                                    style: {
                                                                        borderRadius: "50%",
                                                                        objectFit: "cover"
                                                                    },
                                                                    className: "img-fluid card-img-top carouselImage"
                                                                })
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                className: "ms-3 d-flex align-items-center",
                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                    className: "d-block",
                                                                    children: [
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                                                                            className: "mb-0",
                                                                            children: item.reviewer
                                                                        }),
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                            className: "mt-0",
                                                                            children: [
                                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* FontAwesomeIcon */.G, {
                                                                                    icon: "star",
                                                                                    width: "14",
                                                                                    className: "star ms-0 mt-0",
                                                                                    style: {
                                                                                        color: "#f7ca18"
                                                                                    }
                                                                                }),
                                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* FontAwesomeIcon */.G, {
                                                                                    icon: "star",
                                                                                    width: "14",
                                                                                    className: "star mt-0",
                                                                                    style: {
                                                                                        color: "#f7ca18"
                                                                                    }
                                                                                }),
                                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* FontAwesomeIcon */.G, {
                                                                                    icon: "star",
                                                                                    width: "14",
                                                                                    className: "star mt-0",
                                                                                    style: {
                                                                                        color: "#f7ca18"
                                                                                    }
                                                                                }),
                                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* FontAwesomeIcon */.G, {
                                                                                    icon: "star",
                                                                                    width: "14",
                                                                                    className: "star mt-0",
                                                                                    style: {
                                                                                        color: "#f7ca18"
                                                                                    }
                                                                                }),
                                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* FontAwesomeIcon */.G, {
                                                                                    icon: "star",
                                                                                    width: "14",
                                                                                    className: "star mt-0",
                                                                                    style: {
                                                                                        color: "#f7ca18"
                                                                                    }
                                                                                })
                                                                            ]
                                                                        })
                                                                    ]
                                                                })
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("h5", {
                                                        className: "mt-3",
                                                        children: [
                                                            '"',
                                                            item.review,
                                                            '"'
                                                        ]
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                className: "card-footer bg-white border-0 d-flex justify-content-between align-items-center",
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        className: "d-flex justify-md-content-center ",
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                            className: "mb-0",
                                                            children: item.reviewDept
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                        children: [
                                                            item.reviewDept == "Yoga Retreat" && /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                                                className: "btn btnHover px-3 px-lg-2 px-xl-3",
                                                                onClick: ()=>handleRoute(null, "Yoga Retreat"),
                                                                children: "Yoga Retreats"
                                                            }),
                                                            item.reviewDept == "Online Retreat" && /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                                                className: "btn btnHover px-3 px-lg-2 px-xl-3",
                                                                onClick: ()=>handleRoute(types/* RetreatsTypeEnum.Online */.zZ.Online, null),
                                                                children: "Online Retreats"
                                                            }),
                                                            item.reviewDept == "Yoga Teacher Training" && /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                                                className: "btn btnHover px-3 px-lg-2 px-xl-3",
                                                                onClick: ()=>handleRoute(null, "Yoga Teacher Training"),
                                                                children: "Online Yoga Training"
                                                            })
                                                        ]
                                                    })
                                                ]
                                            })
                                        ]
                                    }, index)
                                })
                            })
                        ]
                    }))
            })
        })
    });
}
/* harmony default export */ var Carousel = (SwipeableTextMobileStepper);
const reviewDetails = [
    {
        reviewerImg: "/images/o0rvpok6fzrchfl1.png",
        reviewer: "Connie Li",
        review: "I booked my Yoga wellness retreat with Book Your Retreats and I absolutely loved it! The program was very well organized and I felt like I was able to learn a lot about myself and my body.",
        reviewDept: "Yoga Retreat"
    },
    {
        reviewerImg: "/images/Bookingname_img7.png",
        reviewer: "Katherine Lee",
        review: "I wasn't sure what to expect from an online retreat, but this one was fantastic! I loved the yoga classes and the healthy eating tips. I felt so relaxed and refreshed after.",
        reviewDept: "Online Retreat"
    },
    {
        reviewerImg: "/images/girl-update-review.jpg",
        reviewer: "Lilou Vidal ",
        review: "I am so grateful that I found your yoga teacher training program! The content was rich and comprehensive, and I loved being able to study at my own pace.",
        reviewDept: "Yoga Teacher Training"
    }
];

;// CONCATENATED MODULE: ./components/ReviewBlock.tsx




function ReviewBlock() {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "container",
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "col-12 bg-white my-3 my-md-5",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "".concat((Home_module_default()).featured, " ").concat((Home_module_default()).reviews),
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "",
                        style: {
                            position: "relative"
                        },
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "d-flex align-items-lg-center align-items-md-center flex-column mb-lg-4 ",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                                    className: "feature-title p-0 fw-bold mt-3 textUpperCase",
                                    children: "Your Review Matters, and your support matters!"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                    className: " small m-0",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                        className: " m-0 feature-paragraph fw-400",
                                        style: {
                                            color: "#333333"
                                        },
                                        children: "Our clients from across the world have their experiences to share with you, do read them!"
                                    })
                                })
                            ]
                        })
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "".concat((Home_module_default()).ReviewBlock, " row"),
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "col-lg-1"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "col-12 col-lg-5 mt-3",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "d-flex ",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                src: "/images/customer.svg",
                                                className: "img-fluid pt-1",
                                                alt: ""
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: "ms-4",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("h4", {
                                                    className: "",
                                                    children: "Over 5000+ people booked their retreats"
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("h6", {
                                                    children: "with us in the last 6 months"
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "d-flex mt-4 mt-lg-4 mt-md-4",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                src: "/images/booking.svg",
                                                className: "img-fluid pt-1",
                                                alt: ""
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: "ms-4",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("h4", {
                                                    className: "",
                                                    children: "97% of them are happy and satisfied"
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("h6", {
                                                    children: "with finding the most quality retreats"
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "d-flex mt-4 mt-lg-4 mt-md-4",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                src: "/images/satisfaction.svg",
                                                className: "img-fluid pt-1",
                                                alt: ""
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: "ms-4",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("h4", {
                                                    className: "",
                                                    children: "4.9 is our average review rating"
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("h6", {
                                                    children: "& we have the most five-star recommendations in-hand"
                                                })
                                            ]
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "col-12 col-lg-5 mt-4 mt-lg-0",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Carousel, {})
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "col-lg-1"
                        })
                    ]
                })
            ]
        })
    });
}
/* harmony default export */ var components_ReviewBlock = (ReviewBlock);


/***/ }),

/***/ 37303:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* reexport safe */ _MainLayout__WEBPACK_IMPORTED_MODULE_0__.Z; }
/* harmony export */ });
/* harmony import */ var _MainLayout__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(43721);



/***/ })

}]);